export default __webpack_public_path__ + "static/Rosacea-cc8f0182d818ff0fcfb99c351f174a63.svg";